import { offlineDb } from "./offlineDb";
import { clearDeviceCustomers } from "./deviceCustomers";

const KEEP_KEYS = ["__theme_color__", "__lang_id__"];

// sales not sent to the server yet
export const countUnsentSales = async () => {
  try {
    return await offlineDb.orders
      .where("status")
      .anyOf(["pending", "syncing", "failed", "permanently_failed"])
      .count();
  } catch (error) {
    return 0;
  }
};

// withSales: false keeps the queued sales (session ended by itself, not logout)
export const clearDeviceData = async ({ withSales = true } = {}) => {
  try {
    const kept = KEEP_KEYS.map((k) => [k, localStorage.getItem(k)]).filter(
      ([, v]) => v != null,
    );
    localStorage.clear();
    kept.forEach(([k, v]) => localStorage.setItem(k, v));
  } catch (error) {
    // storage blocked: nothing to clear
  }
  await clearDeviceCustomers();
  await Promise.all(
    offlineDb.tables
      .filter((t) => withSales || t.name !== "orders")
      .map((t) => t.clear().catch(() => {})),
  );
};
